import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { saveToLocalStorage } from '../utils/localStorage';
import { useNavigation } from './useNavigation';
import { get } from '../utils/iterable/get';

import { PAGES } from '../constants/routes';

import actions from '../actions';

export function usePageSidebar() {
  const dispatch = useDispatch();
  const { PAGE } = useNavigation();
  const page = useMemo(
    function factory() {
      switch (PAGE) {
        case PAGES.ACCOUNT:
        case PAGES.AFFILIATE:
        case PAGES.BILLING: {
          return PAGES.ACCOUNT;
        }

        case PAGES.SCHEDULE:
        case PAGES.SCHEDULE_LISTINGS:
        case PAGES.SCHEDULE_UPDATES: {
          return PAGES.SCHEDULE;
        }

        case PAGES.STUDIO:
        case PAGES.STUDIO_PHOTOS:
        case PAGES.STUDIO_VIDEOS: {
          return PAGES.STUDIO;
        }

        default: {
          return PAGE;
        }
      }
    },
    [PAGE],
  );

  const sidebarHidden = useSelector(get(['data', 'sidebarHidden', page]));
  const toggleSidebar = useCallback(
    function callback() {
      const value = sidebarHidden ? undefined : true;

      saveToLocalStorage({ sidebarHidden: { [page]: value }});

      dispatch(actions.data.setData({ path: ['sidebarHidden', page], value }));
    },
    [sidebarHidden],
  );

  return useMemo(
    function factory() {
      return [sidebarHidden, toggleSidebar];
    },
    [sidebarHidden],
  );
}
